import { combineReducers, configureStore } from '@reduxjs/toolkit'
import constructionReducer from './reducers/construction'
import { thunk } from 'redux-thunk'
import filesReducer from './reducers/files'
import authReducer from './reducers/auth'
import organizationReducer from './reducers/organization'
import { checkUserLoggedIn } from './utils/AuthUtil'
import { setAuthenticated } from './actions/auth'
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import sessionStorage from 'redux-persist/lib/storage/session'
import takeOffReducer from './reducers/takeOff'
import permitReducer from './reducers/permit'
import validationReducer from './reducers/validation'
import structuralReducer from './reducers/structural'
import commentsReducer from './reducers/comments'
import ruleReducer from './reducers/rule'
import reviewReducer from './reducers/review'
import paymentReducer from './reducers/payment'
import historyReducer from './reducers/history'
import bimReducer from './reducers/bim'
import measurementReducer from './reducers/measurement'

const persistOrganizationConfig = {
  key: 'organization',
  storage: sessionStorage,
  blacklist: ['selectedFile', 'is3DViewActive', 'errorMessage'],
}

const persistAuthConfig = {
  key: 'user',
  storage: sessionStorage,
}

const persistReviewConfig = {
  key: 'review',
  storage: sessionStorage,
  blacklist: ['selectedProject', 'isLoadingEngineerOrganization'],
}

const persistedOrganizationReducer = persistReducer(
  persistOrganizationConfig,
  organizationReducer,
)
const persistedAuthReducer = persistReducer(persistAuthConfig, authReducer)
const persistedReviewReducer = persistReducer(
  persistReviewConfig,
  reviewReducer,
)

const rootReducer = combineReducers({
  construction: constructionReducer,
  drawings: filesReducer,
  auth: persistedAuthReducer,
  organization: persistedOrganizationReducer,
  takeOff: takeOffReducer,
  permit: permitReducer,
  validation: validationReducer,
  structural: structuralReducer,
  comments: commentsReducer,
  rule: ruleReducer,
  review: persistedReviewReducer,
  payment: paymentReducer,
  history: historyReducer,
  bim: bimReducer,
  measurement: measurementReducer,
})

const persistedReducer = persistReducer(
  {
    key: 'root',
    storage: sessionStorage,
    whitelist: ['auth', 'organization', 'review'],
  },
  rootReducer,
)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(thunk),
})

const isAuthenticated = checkUserLoggedIn()
if (isAuthenticated) {
  store.dispatch(setAuthenticated(isAuthenticated))
}

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
